import React, { FC, useState } from 'react';
import { Card, Button, message } from 'antd';
import { UploadFile } from 'antd/es/upload/interface';
import { ListeningTypeSelector } from '../ListeningTypeSelector/ListeningTypeSelector';
import { FileUploader } from '../FileUploader/FileUploader';
import { uploadVTTFile } from '../../api/speechToInsightsApi';

interface VTTFileTabProps {
    setIsProcessing: (value: boolean) => void;
    isProcessing: boolean;
}

export const VTTFileTab: FC<VTTFileTabProps> = ({ setIsProcessing, isProcessing }) => {
    const [fileList, setFileList] = useState<UploadFile[]>([]);
    const [listeningType, setListeningType] = useState('');

    const handleListeningTypeChange = (value: string) => {
        setListeningType(value);
    };

    const handleStartProcessing = async () => {
        if (fileList.length === 0) {
            message.error('Por favor, adjunta un archivo VTT');
            return;
        }
    
        const file = fileList[0].originFileObj;
        if (!file) {
            message.error('No se pudo acceder al archivo');
            return;
        }

        if (!listeningType) {
            message.error('Por favor, selecciona un tipo de análisis');
            return;
        }
    
        setIsProcessing(true);
    
        try {
            await uploadVTTFile(file, listeningType); // This triggers the backend to start processing
            message.success('Proceso iniciado correctamente');
        } catch (error) {
            message.error('Error al procesar el archivo VTT');
        } finally {
            setIsProcessing(false);
        }
    };    

    return (
        <Card>
            <ListeningTypeSelector
                value={listeningType}
                onChange={handleListeningTypeChange}
                disabled={isProcessing}
            />
            <FileUploader
                accept=".vtt"
                fileList={fileList}
                onChange={setFileList}
                uploadText="Haz clic o arrastra un archivo .vtt aquí para subir"
                disabled={isProcessing}
            />
            <Button
                type="primary"
                onClick={handleStartProcessing}
                disabled={fileList.length === 0}
                style={{ marginTop: '16px' }}
                block
                loading={isProcessing}
            >
                Iniciar Proceso
            </Button>
        </Card>
    );
};
